import { Reveal, MaskText, Stagger, StaggerItem } from "./Reveal";

const BLOCKS = [
  ["Current Stage", "Where the business or initiative is developmentally — and why."],
  ["The 12-Month Destination", "What you are trying to make true."],
  ["The Big Three", "The three outcomes that matter most."],
  ["What Must Be Proven", "The assumptions that still need evidence."],
  ["Customer + Market", "Who you are building for and why they will buy."],
  ["Business Model", "How money comes in and which economics matter."],
  ["Growth Engine", "How customers discover → trust → buy → return → refer."],
  ["Foundation", "The operations, people, systems and capital required."],
  ["Risks + Watchouts", "What could derail the plan."],
  ["The Not Yet List", "Good ideas your business isn't ready for yet."],
];

const QUARTERS = [["Q1", "Prove"], ["Q2", "Build"], ["Q3", "Grow"], ["Q4", "Prepare for what's next"]];

export const Output = () => (
  <section id="output" className="relative bg-sand py-24 sm:py-32 overflow-hidden">
    <div aria-hidden className="pointer-events-none absolute top-10 -right-10 font-serif italic text-[16vw] leading-none text-ocean/[0.035] select-none">
      roadmap
    </div>
    <div className="relative mx-auto max-w-[1300px] px-5 sm:px-8">
      <div className="max-w-3xl">
        <span className="font-sans text-xs uppercase tracking-[0.28em] text-cognac">The Output</span>
        <h2 className="mt-6 font-serif text-ocean tracking-[-0.02em] leading-[0.98] text-4xl sm:text-5xl lg:text-[4.2rem]">
          <MaskText lines={["This is what you", <span key="w" className="italic text-cognac">walk away with.</span>]} />
        </h2>
        <Reveal delay={0.12}>
          <p className="mt-6 font-sans text-base sm:text-lg text-ink/72 leading-relaxed max-w-xl">
            Not a deck. Not a binder. A single, living document that says what your business is,
            where it's going and what deserves your attention — in this order.
          </p>
        </Reveal>
      </div>

      {/* Editorial document mockup */}
      <Reveal delay={0.1}>
        <div data-testid="roadmap-mockup" className="relative mt-16 mx-auto max-w-5xl bg-cream border border-[var(--line)] shadow-[0_40px_80px_-40px_rgba(10,28,42,0.35)]">
          <div className="px-7 sm:px-12 py-7 border-b border-[var(--line)] flex flex-wrap items-end justify-between gap-4">
            <div>
              <div className="font-sans text-[11px] uppercase tracking-[0.26em] text-cognac">The 12-Month Founder Roadmap</div>
              <div className="mt-2 font-serif text-2xl sm:text-3xl text-ocean tracking-tight">Prepared for <span className="italic">your business</span></div>
            </div>
            <div className="font-sans text-[11px] uppercase tracking-[0.2em] text-ink/45 text-right">
              Built in 7 days<br />Revisited whenever things change
            </div>
          </div>

          <Stagger className="grid sm:grid-cols-2 lg:grid-cols-5 gap-px bg-[var(--line)]" amount={0.05}>
            {BLOCKS.map(([t, b], i) => (
              <StaggerItem key={t} className="bg-cream p-6 sm:p-7 min-h-[150px] flex flex-col">
                <div className="font-sans text-[10px] tracking-[0.2em] text-cognac/80">{String(i + 1).padStart(2, "0")}</div>
                <h3 className="mt-3 font-serif text-lg text-ocean leading-tight tracking-tight">{t}</h3>
                <p className="mt-2 font-sans text-[13px] text-ink/60 leading-relaxed">{b}</p>
              </StaggerItem>
            ))}
          </Stagger>

          <div className="border-t border-[var(--line)] grid lg:grid-cols-12">
            <div className="lg:col-span-8 px-7 sm:px-12 py-8 border-b lg:border-b-0 lg:border-r border-[var(--line)]">
              <div className="font-sans text-[11px] uppercase tracking-[0.24em] text-cognac">Quarterly Roadmap</div>
              <div className="mt-5 grid grid-cols-2 sm:grid-cols-4 gap-6">
                {QUARTERS.map(([q, t]) => (
                  <div key={q} className="border-t-2 border-ocean pt-3">
                    <div className="font-serif text-3xl text-ocean leading-none">{q}</div>
                    <div className="mt-2 font-sans text-xs uppercase tracking-[0.18em] text-ink/70 leading-snug">{t}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="lg:col-span-4 px-7 sm:px-12 py-8 bg-ocean text-cream">
              <div className="font-sans text-[11px] uppercase tracking-[0.24em] text-cognac">Your Next 30 Days</div>
              <div className="mt-4 space-y-2.5">
                {[1, 2, 3, 4, 5].map((n) => (
                  <div key={n} className="flex items-center gap-3">
                    <span className="font-serif text-sm text-cognac w-4">{n}</span>
                    <span className="h-px flex-1 bg-cream/20" />
                  </div>
                ))}
              </div>
              <p className="mt-5 font-serif italic text-xl leading-snug">Five specific actions. <span className="text-cream/55">Not fifty.</span></p>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
